import type { CodeWithMarket, GetHQRequestParams, HqRequestParams } from './types';

function splitCodes(stocks: CodeWithMarket[]): { codes: string[]; markets: string[] } {
  const codes: string[] = [];
  const markets: string[] = [];
  for (const item of stocks) {
    const [code, market] = item.split('_');
    codes.push(code);
    markets.push(market);
  }
  return { codes, markets };
}

export function buildHqRequestParams(options: {
  stocks: CodeWithMarket[];
  onlineId: string;
  protocolId: number;
  pageId: number;
  columOrder: string[];
}) {
  const { codes, markets } = splitCodes(options.stocks);

  const separator = '|';
  const requestDic = [
    'startrow=0',
    `rowcount=${codes.length}`,
    'sortid=-1',
    `columnorder=${options.columOrder.join(separator)}`,
    'newrealtime=1',
    'selfstockcustom=1',
    `stocklist=${codes.join(separator)}`,
    `marketlist=${markets.join(separator)}`,
  ].join('\r\n');

  const params: HqRequestParams = {
    protocolId: String(options.protocolId),
    pageId: String(options.pageId),
    onlineId: options.onlineId,
    requestDic,
    _stocks: options.stocks,
    _columOrder: options.columOrder,
  };

  return params;
}

export function buildGetHQRequestParams(
  stocks: CodeWithMarket[],
  columOrder: string[],
): GetHQRequestParams {
  const { codes, markets } = splitCodes(stocks);

  return {
    stocklist: codes,
    marketlist: markets,
    columnorder: columOrder,
  };
}
